import IconPickerModal from "./IconPickerModal";

export default IconPickerModal;
